<template>
  <div class="container">
    <div class="btn-wrapper">
      <el-button class="add-new-btn" @click="handleChange(1)">
        <i class="iconfont iconProperty1tianjia"></i> Add
      </el-button>
    </div>
    <div>
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="ID" prop="id" min-width="80"></el-table-column>
        <el-table-column
          label="name"
          prop="name"
          show-overflow-tooltip
          min-width="120"
          style="background:red"
        >
          <template v-slot="{row}">
            <div
              class="table-label"
              :style="{color:row.fontColor,background:row.backgroundColor,padding: '10px',borderRadius: '4px'}"
            >{{ row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="User Count" prop="userCount" min-width="90">
          <template v-slot="{row}">
            <div v-if="Number(row.id) == 1">X</div>
            <div v-else>{{ row.userCount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="OddsDrop Group" prop="oddsLevelId" min-width="380">
          <template v-slot="{row}">
            <div v-if="Number(row.id) == 0 || Number(row.id) == 1">X</div>
            <div v-else>
              <span
                style="background: #333;border-radius: 3px;padding: 4px 6px;color: #fff;display: inline-block;margin: 4px 4px 4px 0;"
                v-for="item in row.labelName"
                :key="item"
              >{{ item }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Operation" min-width="270" fixed="right">
          <template v-slot="{row}">
            <div v-if="Number(row.id) == 0 || Number(row.id) == 1">X</div>
            <div v-else>
              <el-button class="table-inner-btn" @click="handleChange(2,row)">Modify</el-button>
              <el-button class="table-inner-btn" @click="handleChange(3,row)">Delete</el-button>
              <el-button class="table-inner-btn" @click="handleChange(4,row)">History</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>-->

    <dia ref="dialogDom" class="label-dialog">
      <!-- 添加1修改2 -->
      <div v-if="num == 2 || num == 1">
        <el-form :model="form" label-width="56px">
          <el-form-item label="Name:">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="OddsDrop Group:">
            <el-table
              ref="table"
              :data="tableItemList"
              height="500"
              header-row-class-name="table-header-row"
              border
            >
              <el-table-column label="Sport" prop="name" min-width="30%">
                <template v-slot="{ row }">
                  <div>{{ row.name }}</div>
                </template>
              </el-table-column>
              <el-table-column label="Market" prop="name" min-width="70%">
                <template v-slot="{ row }">
                  <div>
                    <el-checkbox-group v-model="marketList[row.sportId]">
                      <el-checkbox
                        v-for="item in row.marketVal"
                        :key="item.id"
                        :label="item.id"
                      >{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleViewModify()" v-if="num == 2">Confirm</el-button>
          <el-button class="search-btn" @click="handleViewAdd()" v-if="num == 1">Confirm</el-button>
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
      <!-- 删除3 -->
      <div v-if="num == 3">
        <p>
          OddsDrop Group User Count is
          (
          <span class="user-count">{{userCount}}</span> )
        </p>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="Delete()">Confirm</el-button>
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
      <!-- history4 -->
      <div v-if="num == 4">
        <!-- <div style="margin-bottom: 10px;">Time：2021-11-12 12:12:31</div> -->
        <el-table
          ref="table"
          :data="itemList"
          height="500"
          v-loading="loadingItem"
          header-row-class-name="table-header-row"
          border
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column label="Modify Time" prop="time" min-width="20%">
            <template v-slot="{ row }">
              <div>{{ formatUtc(row.updateTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Level" prop="name" min-width="20%">
            <template v-slot="{ row }">
              <div>{{ row.groupName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="OddsDrop Group" prop="oddsLevel" min-width="40%">
            <template v-slot="{ row }">
              <div>
                <span
                  style="background: #333;border-radius: 3px;padding: 4px 6px;color: #fff;display: inline-block;margin: 4px 4px 4px 0;"
                  v-for="item in row.labelName"
                  :key="item"
                >{{ item }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Modifier" prop="operator" min-width="20%">
            <template v-slot="{ row }">
              <div>{{ row.modifier }}</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="pagination-wrapper inline-wrapper">
          <el-pagination
            class="inline-right"
            :total="totalAert"
            :current-page="queryAlert.current"
            :page-size="queryAlert.size"
            :page-sizes="[50, 100, 200]"
            @current-change="changeAlertPage"
            @size-change="handleSizeAlertChange"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>-->
        <div class="dialog-footer table-search-part" style="padding-top: 20px;">
          <el-button class="clear-btn" @click="CloseHistory()">Cancel</el-button>
        </div>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import {
  getList,
  getOddsDropDelete,
  getOddsDropUpdate,
  getOddsDropAdd,
  getOddsDropOperationLog
} from "@/api/oddsDrop";
import { getLevelList } from "@/api/member";
export default {
  name: "oddsDropList",
  data() {
    return {
      form: {
        name: "",
        id: "",
        configs: []
      },
      loadingItem: false,
      totalAert: 0,
      itemList: [],
      marketList: {
        "1": [],
        "3": [],
        "2": [],
        "4": [],
        "5": [],
        "6": [],
        "7": [],
        "13": [],
        "15": [],
        "14": [],
        "47": [],
        "999999999": []
      },
      tableItemList: [
        {
          sportId: 1,
          name: "Soccer",
          marketVal: [
            { id: 1000, name: "Handicap" },
            { id: 1007, name: "Over/Under" },
            { id: 1005, name: "1x2" },
            { id: 999999999, name: "Others" }
          ]
        },
        {
          sportId: 3,
          name: "Basketball",
          marketVal: [
            { id: 3002, name: "Handicap" },
            { id: 3003, name: "Over/Under" },
            { id: 3004, name: "Winner" },
            { id: 999999999, name: "Others" }
          ]
        },
        {
          sportId: 2,
          name: "Ice Hockey",
          marketVal: [{ id: 0, name: "All" }]
        },
        {
          sportId: 4,
          name: "Rugby",
          marketVal: [{ id: 0, name: "All" }]
        },
        {
          sportId: 5,
          name: "Tennis",
          marketVal: [{ id: 0, name: "All" }]
        },
        {
          sportId: 6,
          name: "American Football",
          marketVal: [{ id: 0, name: "All" }]
        },
        {
          sportId: 7,
          name: "Baseball",
          marketVal: [{ id: 0, name: "All" }]
        },
        {
          sportId: 13,
          name: "Volleyball",
          marketVal: [{ id: 0, name: "All" }]
        },
        {
          sportId: 15,
          name: "Table Tennis",
          marketVal: [{ id: 0, name: "All" }]
        },
        {
          sportId: 14,
          name: "Cricket",
          marketVal: [{ id: 0, name: "All" }]
        },
        {
          sportId: 47,
          name: "Badminton",
          marketVal: [{ id: 0, name: "All" }]
        },
        {
          sportId: 999999999,
          name: "Other Sports",
          marketVal: [{ id: 0, name: "All" }]
        }
      ],
      loadingAlert: false,
      id: "",
      num: "",
      list: [],
      total: 0,
      loading: false,
      queryData: {
        current: 1,
        size: 50
      },
      queryAlert: {
        current: 1,
        size: 50,
        groupId: ""
      },
      oddsLevelList: [
        { id: 0, name: "Config" },
        { id: 1, name: "A" },
        { id: 2, name: "B" },
        { id: 3, name: "C" },
        { id: 4, name: "D" },
        { id: 5, name: "E" },
        { id: 6, name: "F" },
        { id: 7, name: "G" }
      ],
      betIntervalTime: [
        { id: 0, name: "0" },
        { id: 5, name: "5" },
        { id: 15, name: "15" },
        { id: 30, name: "30" },
        { id: 60, name: "60" }
      ],
      alertOddsLevelList: [
        { id: 1, name: "A" },
        { id: 2, name: "B" },
        { id: 3, name: "C" },
        { id: 4, name: "D" },
        { id: 5, name: "E" },
        { id: 6, name: "F" },
        { id: 7, name: "G" }
      ],
      levelList: [],
      labelId: "",
      userCount: "",
      tableHeight: window.innerHeight,
      title: "Delete the Label?"
    };
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await getList(this.queryData);
        const data = res.data || {};
        this.list = data || [];
        this.total = Number(data.total);
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getOddsDropLog() {
      this.loadingAlert = true;
      try {
        const res = await getOddsDropOperationLog(this.queryAlert);
        const data = res.data || {};
        this.itemList = data || [];
        this.totalAert = Number(data.total);
        this.loadingAlert = false;
      } catch (error) {
        this.itemList = [];
        this.loadingAlert = false;
      }
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    formatOddsLevelId(val) {
      let name = "";
      this.oddsLevelList.map(item => {
        if (item.id == val) {
          name = item.name;
        }
      });
      return name;
    },
    formatLevelId(val) {
      let name = "";
      this.levelList.map(item => {
        if (item.id == val) {
          name = item.name;
        }
      });
      return name;
    },
    // 查看详情
    handleViewDetail(data) {
      this.$router.push({
        path: "/risk/detail",
        query: { riskLevelId: data.riskLevelId }
      });
    },
    // 添加
    async handleViewAdd() {
      let configs = [];
      for (let key in this.marketList) {
        let item = this.marketList[key];
        if (item.length > 0) {
          let obj = { sportId: Number(key), marketTypes: item };
          configs.push(obj);
        }
      }
      this.form.configs = configs;
      if (this.form.name) {
        const res = await getOddsDropAdd(this.form);
        if (res.success) {
          this.$message({ message: "add success", type: "success" });
          this.getList();
        }
      } else {
        this.$message({
          message: "The name can not be empty",
          type: "warning"
        });
      }
      this.Close();
    },
    handleChange(num, data) {
      this.num = num;
      if (num == 1) {
        // 添加
        this.title = "Add OddsDrop Template";
        this.marketList = {
          "1": [],
          "3": [],
          "2": [],
          "4": [],
          "5": [],
          "6": [],
          "7": [],
          "13": [],
          "15": [],
          "14": [],
          "47": [],
          "999999999": []
        };
        this.form = {
          name: "",
          configs: [],
          id: ""
        };
        this.$refs["dialogDom"].isShowDia(this.title, true, "800px");
      } else if (num == 2) {
        // 修改
        this.marketList = {
          "1": [],
          "3": [],
          "2": [],
          "4": [],
          "5": [],
          "6": [],
          "7": [],
          "13": [],
          "15": [],
          "14": [],
          "47": [],
          "999999999": []
        };
        data.configs.map(item => {
          this.marketList[item.sportId] = item.marketTypes;
        });
        this.title = "Modify OddsDrop Template";
        this.form.name = data.name;
        this.form.id = data.id;
        this.$refs["dialogDom"].isShowDia(this.title, true, "800px");
      } else if (num == 4) {
        this.queryAlert.current = 1;
        this.queryAlert.size = 50;
        this.title = "OddsDrop Group History";
        this.queryAlert.groupId = data.id;
        this.$refs["dialogDom"].isShowDia(this.title, true, "1100px");
        this.getOddsDropLog();
      } else {
        // 删除
        this.title = "Are you sure to delete Group?";
        this.groupId = data.id;
        this.userCount = data.userCount;
        this.$refs["dialogDom"].isShowDia(this.title, true, "800px");
      }
    },
    // 修改
    async handleViewModify() {
      let configs = [];
      for (let key in this.marketList) {
        let item = this.marketList[key];
        if (item.length > 0) {
          let obj = { sportId: Number(key), marketTypes: item };
          configs.push(obj);
        }
      }

      this.form.configs = configs;
      if (this.form.name != "") {
        const res = await getOddsDropUpdate(this.form);
        if (res.success) {
          this.$message({ message: "update success", type: "success" });
          this.getList();
        }
      } else {
        this.$message({
          message: "The lablename can not be empty",
          type: "warning"
        });
      }
      this.Close();
    },
    // 删除
    async Delete() {
      const res = await getOddsDropDelete({ id: this.groupId });
      if (res.code == 0) {
        this.$message({ message: "delete success", type: "success" });
        this.getList();
        this.Close();
      }
    },
    // 分页
    changeAlertPage(e) {
      this.queryAlert.current = e;
      this.getOddsDropLog();
    },
    // 列表显示条目
    handleSizeAlertChange(e) {
      this.queryAlert.size = e;
      this.queryAlert.current = 1;
      this.getOddsDropLog();
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "800px");
    },
    CloseHistory() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "1100px");
    }
  },
  mounted() {
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  },
  components: {
    dia,
    Empty
  }
};
</script>

<style lang="scss" scoped>
.btn-wrapper {
  margin: 20px 0;
}
.table-label {
  color: #666;
  font-weight: bold;
}
.user-count {
  font-size: 16px;
  font-weight: 600;
  color: #e95353;
}
/deep/.el-form-item__label {
  width: 120px !important;
}
/deep/.el-form-item__content {
  margin-left: 120px !important;
}
</style>
